/* global axios */
// NOTICE: KAPTION-INTEGRATION
// API client for WhatsApp template management (CRUD)
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getTemplates(inboxId, { language, excludeKaption = true } = {}) {
    const params = {};
    if (language) params.language = language;
    params.exclude_kaption = excludeKaption;
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`, { params });
  }

  createTemplate(inboxId, templateData) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      whatsapp_template: templateData,
    });
  }

  suggestCategory(inboxId, content) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_templates/suggest_category`,
      content
    );
  }
}

export default new WhatsappTemplatesAPI();
